module.exports = __webpack_public_path__ + "static/media/emma_vp_vologda_2.0ec3ae16.jpg";